var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GoogleMap } from '@capacitor/google-maps';
import { useRef, useLayoutEffect, useCallback, memo, useState, useEffect, } from 'react';
var DEFAULT_LONGITUDE = 26.058415;
var DEFAULT_LATITUDE = -29.1199066;
var GEOLOCATION_TIMEOUT = 10000;
var MAP_API_KEY = import.meta.env.REACT_APP_MAP_API_KEY ||
    'AIzaSyAmTVxElyncQJh2hJ1ATFS0K_cB6d3VoSk';
var mapInstanceCount = 0;
var geocodeWithMapsJs = function (lat, lng) {
    var _a;
    var maps = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps;
    if (!(maps === null || maps === void 0 ? void 0 : maps.Geocoder)) {
        return Promise.resolve(undefined);
    }
    return new Promise(function (resolve) {
        new maps.Geocoder().geocode({ location: { lat: lat, lng: lng } }, function (results, status) {
            if (status !== 'OK' || !(results === null || results === void 0 ? void 0 : results.length)) {
                resolve(undefined);
                return;
            }
            resolve({
                status: 'OK',
                results: results.map(function (result) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return (__assign(__assign({}, result), { geometry: __assign(__assign({}, result.geometry), { location: {
                                lat: (_d = (_c = (_b = (_a = result.geometry) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.lat) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : lat,
                                lng: (_h = (_g = (_f = (_e = result.geometry) === null || _e === void 0 ? void 0 : _e.location) === null || _f === void 0 ? void 0 : _f.lng) === null || _g === void 0 ? void 0 : _g.call(_f)) !== null && _h !== void 0 ? _h : lng,
                            } }) }));
                }),
            });
        });
    });
};
var geocodeWithRestApi = function (lat, lng) {
    var params = new URLSearchParams({
        latlng: "".concat(lat, ",").concat(lng),
        key: MAP_API_KEY,
    });
    return fetch("https://maps.googleapis.com/maps/api/geocode/json?".concat(params))
        .then(function (response) { return response.json(); })
        .then(function (data) { var _a; return data.status === 'OK' && ((_a = data.results) === null || _a === void 0 ? void 0 : _a.length) ? data : undefined; })
        .catch(function () { return undefined; });
};
var CustomGoogleMapComponent = function (props) {
    var mapRef = useRef();
    var mapIdRef = useRef("google-map-".concat((mapInstanceCount += 1)));
    var mapInstanceRef = useRef(null);
    var isMountedRef = useRef(true);
    var onChangeMapDataRef = useRef(props.onChangeMapData);
    onChangeMapDataRef.current = props.onChangeMapData;
    var _a = useState(null), map = _a[0], setMap = _a[1];
    var _b = useState(false), inititialCoordsSet = _b[0], setInitialCoordsSet = _b[1];
    var _c = useState(props.longitude === undefined || props.longitude === null
        ? DEFAULT_LONGITUDE
        : props.longitude), longitude = _c[0], setLongitude = _c[1];
    var _d = useState(props.latitude === undefined || props.latitude === null
        ? DEFAULT_LATITUDE
        : props.latitude), latitude = _d[0], setLatitude = _d[1];
    var getCoordData = useCallback(function (lat, lng) { return __awaiter(void 0, void 0, void 0, function () {
        var mapData, _a, error_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (lat === undefined ||
                        lng === undefined ||
                        Number.isNaN(lat) ||
                        Number.isNaN(lng)) {
                        return [2];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, , 7]);
                    return [4, geocodeWithMapsJs(lat, lng)];
                case 2:
                    if (!((_b = (_d.sent())) !== null && _b !== void 0)) return [3, 3];
                    _a = _b;
                    return [3, 5];
                case 3: return [4, geocodeWithRestApi(lat, lng)];
                case 4:
                    _a = (_d.sent());
                    _d.label = 5;
                case 5:
                    mapData = _a;
                    if (!isMountedRef.current || !mapData)
                        return [2];
                    (_c = onChangeMapDataRef.current) === null || _c === void 0 ? void 0 : _c.call(onChangeMapDataRef, mapData, {
                        latitude: lat,
                        longitude: lng,
                    });
                    return [3, 7];
                case 6:
                    error_1 = _d.sent();
                    console.warn('Failed to reverse geocode map pin:', error_1);
                    return [3, 7];
                case 7: return [2];
            }
        });
    }); }, []);
    var initMaps = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!map)
                        return [2];
                    if (!mapRef.current)
                        return [2];
                    return [4, GoogleMap.create({
                            id: mapIdRef.current,
                            element: mapRef.current,
                            apiKey: MAP_API_KEY,
                            config: {
                                center: {
                                    lat: latitude,
                                    lng: longitude,
                                },
                                zoom: 15,
                                disableDefaultUI: true,
                            },
                        })];
                case 1:
                    newMap = _a.sent();
                    mapInstanceRef.current = newMap;
                    setMap(newMap);
                    return [4, newMap.setOnMarkerDragEndListener(function (event) {
                            setLongitude(event === null || event === void 0 ? void 0 : event.longitude);
                            setLatitude(event === null || event === void 0 ? void 0 : event.latitude);
                            getCoordData(event === null || event === void 0 ? void 0 : event.latitude, event === null || event === void 0 ? void 0 : event.longitude);
                        })];
                case 2:
                    _a.sent();
                    return [4, newMap.addMarker({
                            coordinate: {
                                lat: latitude,
                                lng: longitude,
                            },
                            draggable: true,
                        })];
                case 3:
                    _a.sent();
                    getCoordData(latitude, longitude);
                    return [2];
            }
        });
    }); };
    useEffect(function () {
        return function () {
            isMountedRef.current = false;
            var instance = mapInstanceRef.current;
            mapInstanceRef.current = null;
            instance === null || instance === void 0 ? void 0 : instance.destroy().catch(function () { return undefined; });
        };
    }, []);
    useLayoutEffect(function () {
        var hasInitialCoords = props.latitude !== undefined &&
            props.latitude !== null &&
            props.longitude !== undefined &&
            props.longitude !== null;
        if (hasInitialCoords) {
            setLatitude(props.latitude);
            setLongitude(props.longitude);
            setInitialCoordsSet(true);
            return;
        }
        if (!navigator.geolocation) {
            setInitialCoordsSet(true);
            return;
        }
        var settled = false;
        var useCoords = function (lat, lng) {
            if (settled)
                return;
            settled = true;
            setLatitude(lat);
            setLongitude(lng);
            setInitialCoordsSet(true);
        };
        var fallbackTimer = window.setTimeout(function () { return useCoords(DEFAULT_LATITUDE, DEFAULT_LONGITUDE); }, GEOLOCATION_TIMEOUT);
        navigator.geolocation.getCurrentPosition(function (position) {
            window.clearTimeout(fallbackTimer);
            var _a = (position === null || position === void 0 ? void 0 : position.coords) || {}, lat = _a.latitude, lng = _a.longitude;
            useCoords(lat || DEFAULT_LATITUDE, lng || DEFAULT_LONGITUDE);
        }, function (error) {
            window.clearTimeout(fallbackTimer);
            console.warn("Defaulting map location: ".concat(error.message));
            useCoords(DEFAULT_LATITUDE, DEFAULT_LONGITUDE);
        }, {
            enableHighAccuracy: true,
            timeout: GEOLOCATION_TIMEOUT,
            maximumAge: 0,
        });
        return function () { return window.clearTimeout(fallbackTimer); };
    }, []);
    useLayoutEffect(function () {
        if (!inititialCoordsSet)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, initMaps()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); })();
    }, [inititialCoordsSet, mapRef]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "component-wrapper" }, { children: _jsx("capacitor-google-map", { ref: mapRef, style: {
                        display: 'inline-block',
                        width: '100%',
                        height: props.height || window.screen.height / 2,
                    } }) })), props.children] }));
};
export var CustomGoogleMap = memo(CustomGoogleMapComponent);
//# sourceMappingURL=google_map.js.map